export default "__VITE_ASSET__Du3DEnjQ__"